import {  Component, OnInit, Input, ViewChild } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { UtilService } from '../../../service/util.service';
import { Storage } from '@ionic/storage';
import { ReportService } from '../../../pages/report/report.service';
import { UserProfile } from '../../../models/user-profile.model';
import { IonicSelectableComponent } from 'ionic-selectable';

@Component({
  selector: 'app-report-other-receiving',
  templateUrl: './report-other-receiving.component.html',
  styleUrls: ['./report-other-receiving.component.scss'],
})
export class ReportOtherReceivingComponent implements OnInit {

  @Input() counterList: any[];
  @Input() warehouseList: any[];
  @Input() purposeList: any[];
  @Input() paramOtherReceivingId: any;
  @Input() paramBranchId: any;
  @Input() paramCounterId: any;
  @Input() paramWarehouseId: any;
  @Input() paramDocDateStart: any;
  @Input() paramDocDateEnd: any;
  @Input() paramPurposeId:any;
  
  
  @ViewChild('branchComponent', { static: false }) branchComponent: IonicSelectableComponent;
  @ViewChild('counterComponent', { static: false }) counterComponent: IonicSelectableComponent;

  branchList: any[];
  otherReceivingId: any;
  counterId: any = null;
  warehouseId: any = null;
  purposeId : any = null;
  docDateStart: any;
  docDateEnd: any;
  branchData: any[] = [];
  token: any;
  userProfile: UserProfile = new UserProfile();
  counterByLogin:any;
  selectedBranchs:any[];
  selectedCounters: any[];
  selectedWarehouses: any[];
  selectedPurposes: any[];
  branchId: any;
  listCounterName:any = '';
  listWarehouseName:any= '';

  constructor(
    public modalController: ModalController,
    private utilService: UtilService,
    private reportService: ReportService,
    private storage: Storage,
    private toastCtrl: ToastController) { }

  ngOnInit() {
    let convertDate = this.utilService.convertDate(new Date());
    let todayDate = convertDate.years + '-' + convertDate.months + '-' + convertDate.dates;
    this.otherReceivingId = this.otherReceivingId ? this.otherReceivingId : null;
    this.docDateStart = this.paramDocDateStart ? this.paramDocDateStart : todayDate;
    this.docDateEnd = this.paramDocDateEnd ? this.paramDocDateEnd : todayDate;
    this.branchId = this.paramBranchId ? this.paramBranchId : '';
    this.counterId = this.paramCounterId ? this.paramCounterId : '';
    this.warehouseId = this.paramWarehouseId ? this.paramWarehouseId : '';
    this.purposeId = this.paramPurposeId ? this.paramPurposeId : '';
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile')
    ])
    .then(([token, profile]) => {
      if(token) {
        this.token = token;
      }
      this.utilService.loadingPresent('Harap tunggu...')
      .then(() => {
        this.userProfile = new UserProfile(profile);
        this.counterByLogin = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
        let options = { 
          "token": this.token,
          "counter_id": this.counterByLogin
        };
        this.reportService.getReportCashierIndex(options).subscribe((response) => {
          this.utilService.loadingDismiss();
          this.branchData = response.results.branch_data;
          let branchIdSplit = this.branchId !== '' ? String(this.branchId).split(',') : [];
          this.selectedBranchs=[];
          for(let i= 0; i < branchIdSplit.length; i++) {        
            let selectedBranch: any = this.branchData.find(x => x.id ==  branchIdSplit[i]);
            if(selectedBranch){
              let idx =this.branchData.indexOf(selectedBranch);
              this.selectedBranchs.push(this.branchData[idx]);            
            }
          }
          this.selectedPurposes =[];
          let purposeIdSplit = this.purposeId !== '' ? String(this.purposeId).split(',') : [];
          for(let i= 0; i < purposeIdSplit.length; i++) {
            let selectedPurpose: any = this.purposeList.find(x => x.id ==  purposeIdSplit[i]);
            if(selectedPurpose){
              let idx =this.purposeList.indexOf(selectedPurpose);
              this.selectedPurposes=(this.purposeList[idx]);            
            }
          }
          this.filterCounterByBranch();
        })
      })
    })
  }
    
  async dismissModal(code: any) {
    let dataReturn: any[] = [];

    if(code === 'generate') {
      let convertDocDateStart = this.utilService.convertDate(this.docDateStart);
      let convertDocDateEnd = this.utilService.convertDate(this.docDateEnd);
      
      if(this.branchId!=''&& this.counterId==''){//jika pilih branch tanpa pilih counter, maka ambil all counter di cabang tsb
        let idCounter =''; 
        for(let i=0;i<this.counterList.length;i++){
          idCounter += this.counterList[i].id+',';
        }
        idCounter = idCounter.replace(/(^,)|(,$)/g, "");
        this.counterId = idCounter;  
      }
      
      this.listCounterName='';
      let counterIdSplit = this.counterId !== '' ? String(this.counterId).split(',') : [];      
      for(let i=0;i<counterIdSplit.length;i++){        
        let selectedCounter: any = this.counterList.find(x => x.id ==  counterIdSplit[i]);
        if(selectedCounter){
          let idx =this.counterList.indexOf(selectedCounter);
          this.listCounterName+= this.counterList[idx]['counter_name']+',';            
        }
      }
      this.listWarehouseName ='';
      let warehouseIdSplit = this.warehouseId !== '' ? String(this.warehouseId).split(',') : [];      
      for(let i=0;i<warehouseIdSplit.length;i++){        
        let selectedWarehouse: any = this.warehouseList.find(x => x.id ==  warehouseIdSplit[i]);
        if(selectedWarehouse){
          let idx =this.warehouseList.indexOf(selectedWarehouse);
          this.listWarehouseName+= this.warehouseList[idx]['warehouse_name']+',';            
        }
      }
      let purposeName='';
      let purposeIdSplit = this.purposeId !== '' ? String(this.purposeId).split(',') : [];      
      for(let i=0;i<purposeIdSplit.length;i++){        
        let selectedPurpose: any = this.purposeList.find(x => x.id ==  purposeIdSplit[i]);
        if(selectedPurpose){
          let idx =this.purposeList.indexOf(selectedPurpose);
          purposeName+= this.purposeList[idx]['purpose_name']+',';            
        }
      }

      let data = {
        otherReceivingId: this.otherReceivingId ? this.otherReceivingId : null,
        branchId: this.branchId  ?  this.branchId : 0,
        counterId: this.counterId ?  this.counterId : 0,
        counterName: this.listCounterName,
        warehouseId :  this.warehouseId ?  this.warehouseId : 0,
        warehouseName : this.listWarehouseName,
        docDateStart: convertDocDateStart.years + '-' + convertDocDateStart.months + '-' + convertDocDateStart.dates,
        docDateEnd: convertDocDateEnd.years + '-' + convertDocDateEnd.months + '-' + convertDocDateEnd.dates,
        purposeId :  this.purposeId  ?  this.purposeId : 0,
        purposeName : purposeName,
      };
      dataReturn.push(data);
    }

    if(code === 'close') {
      dataReturn = [];
    }

    await this.modalController.dismiss(dataReturn);
  }
    
  public getSelectedPurpose(event) {
    this.purposeId = event.value.id;
  }

  public selectCounter(event){
    this.counterId = event.value.id;
    this.filterWarehouseByCounter();
  }

  public selectWarehouse(event){
    let idWarehouse = '';
    if(event.value.length>0){
      for(let i=0;i<event.value.length;i++){
        idWarehouse += event.value[i]['id']+',';
      }
    }
    this.warehouseId = idWarehouse.replace(/(^,)|(,$)/g, "");
  }

  public selectBranch(event){
    this.branchId = event.value.id;
    this.filterCounterByBranch();
  }
  
  filterCounterByBranch(){    
    this.selectedCounters=[];
    let idBranch = '';
    for(let i=0;i<this.selectedBranchs.length;i++){
      idBranch += this.selectedBranchs[i].id+',';
    }
    this.branchId = idBranch.replace(/(^,)|(,$)/g, "");
    let options = { 
      "token": this.token,
      "branch_id": this.branchId,
      "counter_id": this.counterByLogin 
    };
    this.reportService.getCounterByBranchId(options).subscribe((response) => {
      this.utilService.loadingDismiss();      
      this.counterList = [];
      this.counterList = response.results;
      this.counterId = this.paramCounterId ? this.paramCounterId : '';

      let counterIdSplit = this.counterId !== '' ? String(this.counterId).split(',') : [];
      for(let i= 0; i < counterIdSplit.length; i++) {        
        let selectedCounter: any = this.counterList.find(x => x.id ==  counterIdSplit[i]);
        if(selectedCounter){
          let idx =this.counterList.indexOf(selectedCounter);
          this.selectedCounters.push(this.counterList[idx]);            
        }
      }

      this.filterWarehouseByCounter();
    }, () => {
      this.utilService.loadingDismiss();
      this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
    });  
  }
  
  filterWarehouseByCounter(){
    this.selectedWarehouses = [];
    this.warehouseList = [];
    let idCounter = '';
    for(let i=0;i<this.selectedCounters.length;i++){
      idCounter += this.selectedCounters[i].id+',';
    }
    this.counterId = idCounter.replace(/(^,)|(,$)/g, "");
    if(this.counterId){
      let options = { 
        "token": this.token,
        "counter_id": this.counterId ? this.counterId: this.userProfile.counter_id_list      
      };
      
      this.reportService.getWarehouseByCounterId(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.warehouseId = this.paramWarehouseId ? this.paramWarehouseId : '';
       
        this.warehouseList = response.results;
        let warehouseIdSplit = this.warehouseId !== '' ? String(this.warehouseId).split(',') : [];
        for(let i= 0; i < this.branchData.length; i++) {        
          let selectedWarehouse: any = this.warehouseList.find(x => x.id ==  warehouseIdSplit[i]);
          if(selectedWarehouse){
            let idx =this.warehouseList.indexOf(selectedWarehouse);
            this.selectedWarehouses.push(this.warehouseList[idx]);
          }
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    }
  }

  
  confirmBranch() {
    this.branchList = [];
    this.branchComponent.confirm();
    this.branchComponent.close();
    this.branchList = this.branchComponent.value;
    this.filterCounterByBranch();
  }
}
